// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"1e367534","103":"6f42fd43","152":"a262d54c","274":"eaae84f7","333":"f36f6499","413":"85fff79e","428":"3c2544b8","437":"6a15a444","570":"4663e5aa","738":"c3bc8625","761":"4c462b0f","768":"e8d6dcd4","769":"2834a68a","771":"cc5a1f00","927":"56deaf4e","930":"4b31f570"}[chunkId] + ".chunk.js";
};